/* eslint-disable no-nested-ternary */
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useAPIError from '../hooks/useAPIError';
import { ErrorArgsType } from '../types/Types';
import { IconX } from '../Icons';
import { useAuthStore } from '../store/AuthContext';
import { useAppStore } from '../store/AppContext';
import routerLoader from '../i18n/router';
import { HostProvider } from '../utils/HostProvider';

const ErrorMessage: FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { error, removeError, errorBack, warning, oro, addOro } = useAPIError();
  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const dataApp = useAppStore();
  const isApp = dataUser.user.isApp === 'true';
  const status = error?.status;
  const isCaprabo = HostProvider.isCaprabo();

  const URL_ERROR_WEB = isCaprabo
    ? `${process.env.REACT_APP_API_CAPRABO}/clienteLogado/getTK?fromUrl=${
        process.env.REACT_APP_CLUB_CAPRABO
      }${dataApp.lang}/clubcaprabo/&fromApp=${t('caprabo_com')}`
    : `${process.env.REACT_APP_API}/clienteLogado/getTK?fromUrl=${
        process.env.REACT_APP_SERVER_EROSKI_ES
      }${t('link.eroskies')}eroski-club/&fromApp=${t('eroski_es')}`;
  const URL_ERROR_APP = isCaprabo
    ? `${HostProvider.getHost()}${dataApp.lang}/backTowebExterna`
    : `${HostProvider.getHost()}${dataApp.lang}/backTowebExterna`;

  const handleSubmit = () => {
    removeError();
    addOro(false);
    if (warning?.message === undefined && status === 'KO') {
      if (isApp) {
        document.location.href = URL_ERROR_APP;
      } else {
        document.location.href = URL_ERROR_WEB;
      }
    } else if (status === 'TARJETA-KO') {
      window.location.href = routerLoader.LoadRouterByPath(
        'tarjetas',
        dataApp.lang,
      );
    }
  };

  const titleModal = () => {
    let title = '';
    // eslint-disable-next-line no-unused-expressions
    errorBack?.title?.forEach((err: ErrorArgsType) => {
      if (err.key) {
        if (err.arguments) {
          title = `${title} ${t(err.key.split('.').join('-'), {
            key: err.arguments,
          })}`;
        } else {
          title = `${title} ${t(err.key.split('.').join('-'))}`;
        }
      }
    });

    return title;
  };

  const titleClasName =
    oro && !error?.style ? 'modal__card-title-oro' : 'modal__card-title';
  const titleMessage = error?.message
    ? error?.message
    : warning?.message
    ? warning?.message
    : titleModal();
  const userMessageModal = () => {
    let text = '';
    // eslint-disable-next-line no-unused-expressions
    errorBack?.userMessage?.forEach((err: ErrorArgsType) => {
      if (err.key) {
        if (err.arguments) {
          text = `${text} ${t(err.key.split('.').join('-'), {
            key: err.arguments,
          })}`;
        } else {
          text = `${text} ${t(err.key.split('.').join('-'))}`;
        }
      }
    });

    return text;
  };

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      const element = document.getElementById('modal-error') as HTMLElement;
      element.removeEventListener('keydown', saveInfo, false);
      e.preventDefault();
      e.stopPropagation();
      handleSubmit();
    }
  };
  useEffect(() => {
    if (
      error?.message ||
      errorBack?.errorCode ||
      warning?.message !== undefined
    ) {
      const element = document.getElementById('modal-error') as HTMLElement;
      element.setAttribute('tabindex', '0');
      element.focus();
      element.addEventListener('keydown', saveInfo, false);
    }
  });

  useEffect(() => {
    if (error?.status === 'TARJETA-KO') {
      addOro(true);
    }
  });

  return (
    <>
      <div
        className={`modal modal--small ${
          error?.message ||
          errorBack?.errorCode ||
          warning?.message !== undefined
            ? 'is-active'
            : ''
        }`}
        id="modal-error"
      >
        <div className="modal__background" />
        <div className="modal__card u-text-center">
          <header className="modal__card-head u-flex">
            <div className={titleClasName}>{titleMessage}</div>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              href="#"
              className="modal__card-close"
              modal-cerrar="true"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleSubmit();
              }}
            >
              <div className="icon icon-medium icon--close">
                <IconX classCss="" />
              </div>
            </a>
          </header>
          <section className="modal__card-body">
            {error?.message ? <p /> : <p>{userMessageModal()}</p>}
            <div className="modal__botonera">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href="#"
                className={
                  oro && !error?.style ? 'btn btn-oro' : 'btn btn-primary'
                }
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleSubmit();
                }}
              >
                {t('entendido')}
              </a>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};
export default ErrorMessage;
